import Immutable from 'seamless-immutable';
import { Setting } from '../stores';
import { SettingActions } from '../actions';

const initialState = Immutable(Setting);

export function setting(state = initialState, action) {
	switch (action.type) {
		case SettingActions.LoadAgreementHistoriesAction.Success: {
			return state.merge({ agreementHistories: action.payload });
		}
		case SettingActions.GetAgreementAction.Success: {
			return state.merge({ agreement: action.payload });
		}
		case SettingActions.UnloadAgreementAction.Success: {
			return state.merge({ agreement: null });
		}
		case SettingActions.GetAttachmentConfigsAction.Success: {
			let commentsConfig = action.payload.find((item) => item.placeOfUse === 0);
			let resultsPublishofficeConfig = action.payload.find((item) => item.placeOfUse === 1);

			return state.merge({
				attachmentConfig: {
					comments: commentsConfig,
					resultsPublish: resultsPublishofficeConfig
				}
			});
		}
		case SettingActions.GetPasswordConfigsAction.Success: {
			let backofficeConfig = action.payload.find((item) => item.appType === 0);
			let frontofficeConfig = action.payload.find((item) => item.appType === 1);

			return state.merge({
				passwordConfig: {
					backoffice: backofficeConfig,
					frontoffice: frontofficeConfig
				}
			});
		}
		case SettingActions.GetThematicAreaAction.Success: {
			return state.merge({ thematicArea: action.payload });
		}
		case SettingActions.LoadThematicAreasAction.Success: {
			return state.merge({ thematicAreas: action.payload });
		}
		case SettingActions.UnloadThematicAreaAction.Success: {
			return state.merge({ thematicArea: null });
		}
		case SettingActions.FetchTemplatesAction.Success: {
			return state.merge({
				templates: action.payload
			});
		}
		case SettingActions.GetTemplateAction.Success: {
			return state.merge({ template: action.payload });
		}
		case SettingActions.GetAuthorizationServiceSettingsAction.Success: {
			return state.merge({ authorizationSettings: action.payload });
		}
		case SettingActions.GetCommentConfigsAction.Success: {
			return state.merge({ commentConfig: action.payload[0] });
		}
		default: {
			return state;
		}
	}
}
